import React from 'react';

const SidebarCollepseIcon = (props) => {
  return (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 2V26" stroke="#99A0AE" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
};

export default SidebarCollepseIcon;
